import { useProperty, useTranslation } from '@eti/providers';
import { useRef } from 'react';
import { useLinksAccessibility } from '../../custom-hooks/useLinkAccessibility';
import { useProductSnowplowTracking } from '../../custom-hooks/useProductSnowplowTracking';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { useIllustration } from '../../common/utils/useIllustration';
import { BAGGAGE_SERVICE } from '../../products';
import { getProduct } from '../../single-choice/utils/singleChoiceTransformer';
import { getModal, getPriceProps, getReadMoreLabel, getSingleChoiceProps, getUpsellProps } from '../../common/utils/productCardProps';
import getTranslatedTexts from '../../common/text-resolvers/utils/getTranslatedTexts';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = BAGGAGE_SERVICE;
export const texts = {
  additionalInformation: 'baggageServiceAdditionalInformation',
  description: 'baggageServiceAbstract',
  title: 'baggageServiceTitle',
  persuasionContent: 'baggageServicePersuasionContent',
  upSell: 'baggageServiceUpSellText',
  readMoreContent: 'baggageServiceReadMoreModalContent'
};
const MainBaggageService = _ref => {
  var _order$persuasion$isE, _order$persuasion;
  let {
    className,
    form,
    isSelected,
    order,
    productPosition,
    sellSpecification,
    layoutType
  } = _ref;
  const {
    t,
    nonDebugT
  } = useTranslation();
  const translation = getTranslatedTexts(texts, t);
  const {
    p
  } = useProperty();
  const illustrationUrl = useIllustration(PRODUCT_NAME);
  const rootElement = useRef(null);
  useProductSnowplowTracking(PRODUCT_NAME, {
    productPosition,
    rootElement
  });
  const product = getProduct(BAGGAGE_SERVICE.id, order, 'traveler');
  const {
    additionalInformation,
    description,
    title,
    persuasionContent,
    readMoreContent
  } = translation;
  useLinksAccessibility({
    targetElement: rootElement,
    productTitle: title
  });
  if (!product) {
    return null;
  }
  const {
    priceRaw
  } = product;
  const {
    upSellObject,
    isUpsellHighlight = false,
    shouldDisplayUpsell = false
  } = getUpsellProps(translation.upSell);
  const {
    priceLabel,
    price,
    priceSuffix
  } = getPriceProps(t, isSelected, product);
  const extraProps = getSingleChoiceProps(t, p, nonDebugT);
  const productCardModal = getModal((_order$persuasion$isE = (_order$persuasion = order.persuasion) === null || _order$persuasion === void 0 ? void 0 : _order$persuasion.isEnabled) !== null && _order$persuasion$isE !== void 0 ? _order$persuasion$isE : false, '', persuasionContent !== null && persuasionContent !== void 0 ? persuasionContent : '');
  const readMoreButtonLabel = getReadMoreLabel(t);
  const productData = {
    additionalInformation,
    extraProps,
    className,
    description,
    form,
    illustrationUrl,
    isHighlighted: isUpsellHighlight,
    isSelected,
    layoutType,
    price,
    priceLabel,
    priceRaw,
    priceSuffix,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productPosition,
    shouldDisplayUpsell,
    title,
    travelers: order.travelers,
    upSell: upSellObject,
    productCardModal,
    sellSpecification,
    readMoreButtonLabel,
    readMoreContent
  };
  return /*#__PURE__*/_jsx(ProductLayout, {
    productData: productData,
    ref: rootElement
  });
};
export default MainBaggageService;
//# sourceMappingURL=MainBaggageService.js.map